import "components/radio-button"
import "components/toggle-button"
import "components/weather-icon"
import "components/temp-value"

import { WindIcon } from "components/wind-icon"
import initSwellIcons from "components/swell-icon"
import { TempValue } from "components/temp-value"
import tideTable from "components/tide-table"
import switchUnits from "components/switch-units"
import { loadTides } from "utils/tide/tides"
import Units from "utils/units" // eslint-disable-line import/no-named-as-default
import DomLoaded from "utils/dom-loaded"
import PageLoaded from "utils/page-loaded"
import "fc-ads/fc-ads.scss"
import init from "init/application"
import statistics from "components/statistics"
import forecastTable from "components/forecast-table"
import langSelector from "components/lang-selector"
import scrollButton from "components/scroll-button/scroll-button"
import "components/carousel/carousel"
import "components/breakheader"
import "components/guideheader"
import "components/seo-section"
import "components/guide-page"
import "components/forecast-cta"
import "components/nearby-points"
import "components/t-shirt-comp"
import "components/print-link"
import "components/join-incentives"
import "components/signup-prompts"
import "components/external-webcam-links"
import "components/nearest-webcams"
import "components/page-footer"
import "components/print-header"
import "components/language-flags"
import "components/country-flag"
import "components/star-rating"
import "components/app-store"
import "components/app-buttons"
import "components/sea-temp"
import "components/profile"
import "components/alert-table"
import "components/main-page-header"
import "components/page-header-small"
import "components/password"
import "components/login"
import "components/buttons"
import "components/outside-buttons"
import "components/apple-buttons"
import "components/google-buttons"
import "components/homepage-hero"
import "components/dropdown-search"
import "components/dropdown-search-combo"
import "components/outside-promo-page"
import "components/outside-page"
import "components/subscribe"
import { initWindStateTooltips } from "components/forecast-table/wind-state/tooltip/tooltip"
import { PageHeader } from "components/page-header"
import { GreenroomArticles } from "components/greenroom-articles"
import { Tweets } from "components/tweets"
import { BreakHeader } from "components/breakheader"
import { Smartbar } from "components/smartbar"
import tidesDot from "components/tides-dot"
import initTooltip from "components/tooltip"
import resortWebcams from "components/resort-webcams"
import alertForm from "components/alert-form"
import { Leaflet } from "components/leaflet"
import IncentiveWrapper from "components/leaflet/incentive-wrapper"
import { TidesCountdown } from "components/tides-countdown"
import { SignUp } from "components/signup/index.tsx"
import { SignupPage } from "components/signup-page"
import { Nearby } from "components/nearby"
import { MapNodesDebug } from "components/map-nodes-debug"
import { TabNavigationComponent } from "components/profile"
import { Banner } from "components/questionnaire-banner"
import galleryPhoto from "components/gallery-photo"

import "static"
import "init/styles/custom.scss"

const meta = document.querySelector("meta[name=csrf-token]")
const token = meta ? meta.content : ""

DomLoaded(() => {
  init()
  statistics()
  forecastTable()
  langSelector()
  scrollButton()
  initTooltip()
  resortWebcams()
  MapNodesDebug()
  initWindStateTooltips()
  galleryPhoto({
    token,
    loggedIn: window.FCGON?.logged_in || false,
    memberMode: window.FCGON?.member_mode || false,
    location: window.FCGON?.location_filename,
  })

  switchUnits()
  loadTides()
  tideTable(window.FCGON || {})
  alertForm()
  WindIcon.init(document, {})
  initSwellIcons(document, Units)
  TempValue.init(document.body)
  Smartbar.init(document.body)
  TabNavigationComponent.init(document.body)
  Banner.init(document.body)
  PageHeader.init(document.body)
  SignupPage.init(document.body)
  GreenroomArticles.init(document.body)
  new SignUp(document.body)
  TidesCountdown.init(document)
  IncentiveWrapper.init(document.body)

  if (document.body.classList.contains("js-units-i")) {
    Units.change({
      temperature: "Imperial",
      length: "Imperial",
      speed: "Imperial",
    })
  }

  const switchSurfUnits = (newUnits) => {
    const val = newUnits === "i" ? "Imperial" : "Metric"
    Units.change({ temperature: val, length: val, speed: val })
  }
  window.switchSurfUnits = switchSurfUnits

  Units.onChange((changes) => {
    if (!window.unitsConv || !changes) return

    if (
      changes.temperature === "Imperial" ||
      changes.length === "Imperial" ||
      changes.speed === "Imperial"
    ) {
      window.unitsConv.switchFCUnits("i")
    } else if (
      changes.temperature === "Metric" ||
      changes.length === "Metric" ||
      changes.speed === "Metric"
    ) {
      window.unitsConv.switchFCUnits("m")
    }
  })

  if (window.FCGON && window.FCGON.maps) {
    Leaflet.init(document.body, window.FCGON.maps)
  }

  Nearby.init(document.body, {})
  Tweets.init(document.body)
  BreakHeader.init(document.body)
})

PageLoaded(() => {
  tidesDot()
  document.body.classList.add("loaded")
})
